import { render, staticRenderFns } from "./SpecificDonationsOverview.vue?vue&type=template&id=22e1ec5b&scoped=true"
import script from "./SpecificDonationsOverview.vue?vue&type=script&lang=js"
export * from "./SpecificDonationsOverview.vue?vue&type=script&lang=js"
import style0 from "./SpecificDonationsOverview.vue?vue&type=style&index=0&id=22e1ec5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1ec5b",
  null
  
)

export default component.exports